import * as ReactDOM from "react-dom";
import { initializeIcons } from "@fluentui/react";

import LiveScoreboard from "@/components/scoreboardPage/LiveScoreboard";

// Initialize Fluent UI icons
initializeIcons();

window.onload = () => {
    const element: HTMLElement | null = document.getElementById("root");
    if (element) {
        ReactDOM.render(<LiveScoreboard
            title="2026 ACF Nationals Scoreboard"
            pollInterval={30000}
        />, element);
    }
};
